import Vue from 'vue'
import App from './App.vue'
import Cookies from 'js-cookie'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import router from './router'
import store from './store'
import messages from './common/language/index'
import Table from './components/Table'
import Pagination from './components/Pagination'
import DropDown from './components/DropDown'
import noData from './components/noData'
import config from './common/config/index'

import ElementLocale from 'element-ui/lib/locale'

Vue.component('Table', Table)
Vue.component('Pagination', Pagination)
Vue.component('DropDown', DropDown)
Vue.component('noData', noData)

Vue.use(ElementUI, { locale })
const language = Cookies.get(config.language) || 'english'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: language,
  messages
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

// const i18n = new VueI18n({
//   locale: 'english',
//   messages
// })

window.ENi18n = i18n
// 添加loadmore指令，以便实现滚动到底加载更多数据
Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function () {
      if (this.scrollHeight - this.scrollTop <= this.clientHeight) {
        binding.value();
      }
    })
  }
})

// 处理数组 返回当前环境中的对应的语言字段
Vue.prototype.handleGlobalArr = function (arr) {
  return arr.map(n => {
    return {
      name: n[language === 'spanish' ? 'spName' :language === 'portuguese' ? 'poName' : 'name'],
      value: n.value,
      oriName: n.oriName
    }
  })
}

Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
